import React, { useRef, useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import InfinityCard from "../components/InfinityCard";
import NeoButton from "../components/NeoButton";
import { useNavigate } from "react-router-dom";
import { MainContext } from "../App";
import FeaturedCharacterSlider from "../components/StoreScreen/FeaturedCharacterSlider";
import { useCardStore } from "../@shared/store/useCardsStore";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutModal from "../components/StoreScreen/CheckoutModal";
import axios from "axios";
import SpriteAnimator from "../components/gamePlay/SpriteAnimator";
import { Add, ArrowBackIos } from "@mui/icons-material";
import NeoMenuItem from "../components/NeoItem";
import { useAuthStore } from "../@shared/store/useAuthStore";
import { formatNumber } from "../@shared/utils/Utils";
import CharacterCard from "../components/CharacterCard";
import HorizontalScrollContainer from "../components/HorizontalScrollContainer";
import { db } from "../@shared/firebase/config";
import {
  addDoc,
  updateDoc,
  getDocs,
  collection,
  doc,
  increment,
} from "firebase/firestore";
import { generateCardPack } from "../@shared/game/cardPackEngine";
import { motion, AnimatePresence } from "framer-motion";
import CloseIcon from "@mui/icons-material/Close";
import Toast from "../components/Toast";

const StoreScreen = () => {
  const { productType } = useParams();
  const {
    Theme,
    navigate,
    setScreenLoading,
    setMessage,
    setError,
    setInfo,
    setSuccess,
  } = useContext(MainContext);
  const { userData } = useAuthStore();
  const { infinityCards, characterCards } = useCardStore();
  const [tab, setTab] = useState(0);
  const [purchaseSuccessType, setPurchaseSuccessType] = useState(null);

  const [cosmeticsTab, setCosmeticsTab] = useState(0);
  const [avatars, setAvatars] = useState(null);
  const [skins, setSkins] = useState(null);
  const [stickers, setStickers] = useState(null);
  const [emotes, setEmotes] = useState(null);
  const [screens, setScreens] = useState(null);
  const [userCosmetics, setUserCosmetics] = useState(null);
  const [loadingCosmetics, setLoadingCosmetics] = useState(false);

  console.log("user data", userData);

  const availCharacters = characterCards.filter(
    (c) => !!c.availableForPurchase
  );
  const availInfinityCards = infinityCards.filter((c) => c.finite === "TRUE");
  const isTest = window.location.origin.includes("localhost");

  const tokensForPurchase = [
    {
      name: "500 Tokens",
      price: 499,
      description: "1000 Tokens",
      image: require("../@shared/assets/icons/500-tokens.png"),
      deal: null,
    },
    {
      name: "1000 Tokens",
      price: 999,
      description: "1000 Tokens",
      image: require("../@shared/assets/icons/1000-tokens.png"),
      deal: null,
    },
    {
      name: "2000 Tokens",
      price: 1999,
      description: "1000 Tokens",
      image: require("../@shared/assets/icons/2000-tokens.png"),
      deal: null,
    },
    {
      name: "2500 Tokens",
      price: 2399,
      description: "2500 Tokens",
      image: require("../@shared/assets/icons/2500-tokens.png"),
      deal: null,
    },
    {
      name: "5000 Tokens",
      price: 4499,
      description: "5000 Tokens",
      image: require("../@shared/assets/icons/5000-tokens.png"),
      deal: 0.8,
    },
    {
      name: "10000 Tokens",
      price: 8499,
      description: "10000 Tokens",
      image: require("../@shared/assets/icons/10000-tokens.png"),
      deal: 0.75,
    },
  ];
  const packsForPurchase = [
    {
      name: "Infinity Pack",
      price: 799,
      description: "A basic pack of cards",
      image: require("../@shared/assets/cardpack_basic.png"),
      deal: null,
    },
    {
      name: "Elemental Pack",
      price: 799,
      description: "A pack of cards with a mix of elements",
      image: require("../@shared/assets/cardpack_basic.png"),
      deal: null,
    },
    {
      name: "Collection Pack",
      price: 799,
      description: "A pack of cards dedicated to the collection",
      image: require("../@shared/assets/cardpack_basic.png"),
      deal: null,
    },
  ];
  //   const spriteRef = useRef();

  const fetchCosmetics = async (type) => {
    try {
      setLoadingCosmetics(true);

      const colRef = collection(db, type);
      const snapshot = await getDocs(colRef);
      const items = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

      switch (type) {
        case "avatars":
          setAvatars(items);
          break;
        case "skins":
          setSkins(items);
          break;
        case "emotes":
          setEmotes(items);
          break;
        case "stickers":
          setStickers(items);
          break;
        case "loadingScreens":
          setScreens(items);
          break;
        default:
          break;
      }
    } catch (error) {
      console.error("Failed to fetch cosmetics:", error);
    } finally {
      setLoadingCosmetics(false);
    }
  };

  const fetchUserCosmetics = async () => {
    try {
      setLoadingCosmetics(true);
      const productTypes = [
        "avatars",
        "skins",
        "emotes",
        "stickers",
        "loadingScreens",
      ];
      let newData = {};

      userData.purchases.forEach((purchase) => {
        const productType = purchase.productType;
        if (productTypes.includes(productType)) {
          if (!newData[productType]) {
            newData[productType] = [];
          }
          newData[productType].push(purchase);
        }
      });

      setUserCosmetics(newData);
    } catch (error) {
      console.error("Failed to fetch user cosmetics:", error);
    } finally {
      setLoadingCosmetics(false);
    }
  };

  // Purchase modal state
  const [clientSecret, setClientSecret] = useState(null);
  const [checkoutOpen, setCheckoutOpen] = useState(false);

  const handleCharacterPurchase = async (character) => {
    try {
      const Seller = await db
        .collection("users")
        .where("stripeTestId", "==", character.ipProviderTestStripeId)
        .get()
        .then(async (querySnapshot) => {
          if (querySnapshot.empty) {
            console.log("No matching documents.");
            return;
          }

          //update the users sales collection
          const sellerDoc = querySnapshot.docs[0];
          const seller = { ...sellerDoc.data(), id: sellerDoc.id };

          return seller;
        });

      const { data } = await axios.post(
        "https://us-central1-infinft-card-game.cloudfunctions.net/app/purchase_character",
        {
          name: character.name,
          metadata: {
            productType: "Character card",
            productDocId: character.id,
            customerUID: userData.id,
            sellerStripeId: character.ipProviderTestStripeId,
            test: isTest,
          },
          country: Seller.country,
          price: Number(character.price),
          ipStripeId: character.ipProviderTestStripeId,
          url: window.location.href,
          test: isTest,
        }
      );

      if (!data.client_secret) {
        alert("No client secret returned from server.");
        return;
      }

      setClientSecret(data.client_secret);
      setCheckoutOpen(true);
    } catch (err) {
      console.error("Purchase error:", err.response?.data || err.message);
      alert("Failed to start purchase.");
    }
  };

  const handlePackPurchase = async () => {
    let testCards = [
      ...characterCards.map((card, i) => {
        return {
          ...card,
          ipProviderTestStripeId: "acct_1RTaBeR0Ukg6JVm9",
          collectionTestStripeId: "acct_1RTaBeR0Ukg6JVm9",
        };
      }),
    ];
    const pack = generateCardPack(
      infinityCards,
      isTest ? testCards : characterCards
    );
    console.log("handlePackPurchase", pack);

    const ipProviders = pack
      .map((c) => c.ipProviderTestStripeId)
      .filter(Boolean);
    const collections = pack
      .map((c) => c.collectionTestStripeId)
      .filter(Boolean);

    const cardsString = pack
      .map((c) => {
        if (c.max) {
          return `Infinity-${c.id}`;
        } else {
          return `Chacracter-${c.id}`;
        }
      })
      .join(", ");

    console.log("cardsString", cardsString);

    const uniqueIPs = [...new Set(ipProviders)].join(",");
    const uniqueCols = [...new Set(collections)].join(",");

    try {
      const { data } = await axios.post(
        "https://us-central1-infinft-card-game.cloudfunctions.net/app/purchase_pack",
        {
          name: "Pack Purchase",
          price: 799,
          metadata: {
            productType: "Pack",
            price: 799,
            productDocId: `pack_${Date.now()}`,
            customerUID: userData.id,
            ipProviderStripeIds: uniqueIPs,
            collectionStripeIds: uniqueCols,
            cards: cardsString,
            test: isTest,
          },
          url: window.location.href,
          test: isTest,
        }
      );

      if (!data.client_secret) {
        alert("No client secret returned.");
        return;
      }

      setClientSecret(data.client_secret);
      setCheckoutOpen(true);
    } catch (err) {
      console.error("Pack Purchase Error:", err.response?.data || err.message);
      alert("Failed to start purchase.");
    }
  };

  const handleInfinityCardPurchase = async (card, price) => {
    try {
      const { data } = await axios.post(
        "https://us-central1-infinft-card-game.cloudfunctions.net/app/purchase_infinity_card",
        {
          name: card.name,
          metadata: {
            productType: "Infinity card",
            productDocId: card.id,
            customerUID: userData.id,
            test: isTest,
          },
          price: price,
          url: window.location.href,
          test: isTest,
        }
      );

      if (!data.client_secret) {
        alert("No client secret returned.");
        return;
      }

      setClientSecret(data.client_secret);
      setCheckoutOpen(true);
    } catch (err) {
      console.error(
        "Infinity Card Purchase error:",
        err.response?.data || err.message
      );
      alert("Failed to purchase.");
    }
  };

  const handleInfinityCardPurchaseWithTokens = async (card, cardPrice) => {
    if (userData.infinityTokens < cardPrice) {
      alert("Not enough Infinity Tokens");
      return;
    }

    try {
      // Example Firestore update – adjust as needed
      await updateDoc(doc(db, "users", userData.id), {
        infinityTokens: increment(-cardPrice),
      });

      await addDoc(collection(db, "users", userData.id, "purchases"), {
        productType: "Infinity card",
        price: cardPrice,
        date: new Date().getTime(),
        product: card,
        claimed: false,
        usedTokens: cardPrice,
      });

      alert("✅ Card claimed using Infinity Tokens!");
    } catch (err) {
      console.error("Token purchase failed:", err.message);
      alert("Failed to claim with tokens.");
    }
  };

  const handleTokenPurchase = async (tokenDeal) => {
    try {
      const { data } = await axios.post(
        "https://us-central1-infinft-card-game.cloudfunctions.net/app/purchase_tokens",
        {
          name: tokenDeal.name,
          price: tokenDeal.price,
          amount: Number(tokenDeal.name.split(" ")[0]), // e.g. "500 Tokens" => 500
          metadata: {
            productType: "Infinity Tokens",
            customerUID: userData.id,
            test: isTest,
            amount: Number(tokenDeal.name.split(" ")[0]),
          },
          url: window.location.href,
          test: isTest,
        }
      );

      if (!data.client_secret) {
        alert("No client secret returned.");
        return;
      }

      setClientSecret(data.client_secret);
      setCheckoutOpen(true);
    } catch (err) {
      console.error("Token Purchase error:", err.response?.data || err.message);
      alert("Failed to start token purchase.");
    }
  };

  const handleCosmeticPurchase = async (item) => {
    if (userData.infinityTokens < item.tokenPrice) {
      setMessage("Not enough tokens!");
      setError(true);
      return;
    }

    const getCollection = () => {
      return ["avatars", "skins", "emotes", "stickers", "loadingScreens"][
        cosmeticsTab
      ];
      return "";
    };

    try {
      await updateDoc(doc(db, "users", userData.id), {
        infinityTokens: increment(-item.tokenPrice),
      });

      const timeOfPurchase = Date.now();

      await addDoc(collection(db, "users", userData.id, "purchases"), {
        amount: 1,
        claimed: false,
        date: timeOfPurchase,
        price: Number(item.tokenPrice * 0.01),
        product: item,
        productType: getCollection(),
      });

      await addDoc(collection(db, "transactions"), {
        customerUID: userData.id,
        sellerStripeIds: [],
        collectionIds: [],
        price: Number(item.tokenPrice * 0.01),
        date: timeOfPurchase,
        product: item,
        amount: 1,
        productType: getCollection(),
      });

      navigate(`/store/success/${getCollection()}`);
    } catch (err) {
      console.error("Cosmetic purchase failed:", err.message);
      alert("Failed to purchase cosmetic.");
    }
  };

  const hasUserPurchased = (item) => {
    const tabKey = ["avatars", "skins", "emotes", "stickers", "loadingScreens"][
      cosmeticsTab
    ];
    const userItems = userCosmetics?.[tabKey] || [];
    return userItems.some((owned) => owned?.product?.id === item.id);
  };

  useEffect(() => {
    setScreenLoading(false);
  }, []);

  useEffect(() => {
    if (userData && !userCosmetics) {
      fetchUserCosmetics();
    }
    console.log(userCosmetics);
  }, [userData, userCosmetics]);

  useEffect(() => {
    if (productType) {
      setPurchaseSuccessType(productType.replace("-", " "));
      const timer = setTimeout(() => {
        setPurchaseSuccessType(null); // Auto-close after some time
        navigate("/store");
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [productType]);

  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        backgroundColor: "#6f52ed", // Purple background for the whole screen
        boxSizing: "border-box",
        backgroundImage: {
          xs: `url(${require("../@shared/assets/storebgmobile.png")})`,
          md: `url(${require("../@shared/assets/storebg.png")})`,
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
        border: "1px solid #fff",
        position: "relative",
      }}
    >
      <Toast onFinish={() => {}} timeTilClose={3000} />
      <AnimatePresence>
        {purchaseSuccessType && (
          <motion.div
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.4 }}
            style={{
              position: "fixed",
              top: "10%",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 9999,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#fff",
                border: `3px solid ${Theme.palette.secondary.main}`,
                borderRadius: 4,
                p: 3,
                minWidth: 280,
                textAlign: "center",
                boxShadow: 6,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: Theme.palette.primary.main,
                  fontWeight: "bold",
                  mb: 1,
                }}
              >
                ✅ Purchase Successful!
              </Typography>
              <Typography sx={{ mb: 2 }}>
                Thanks for purchasing a <strong>{purchaseSuccessType}</strong>!
              </Typography>
              <NeoButton
                isIcon={true}
                icon={<CloseIcon />}
                onClick={() => {
                  setPurchaseSuccessType(null);
                  navigate("/store");
                }}
                color={Theme.palette.tirciary.main}
              />
            </Box>
          </motion.div>
        )}
      </AnimatePresence>

      {/* STORE HEADER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mb: 3,
          backgroundColor: Theme.palette.primary.main,
          borderBottom: `5px solid ${Theme.palette.primary.dark}`,
          borderTop: `5px solid ${Theme.palette.primary.light}`,
          p: 2,
          position: "relative",
        }}
      >
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "2%",
            transform: "translate(0%, -50%)",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <NeoButton
            isIcon={true}
            icon={
              <ArrowBackIos
                style={{
                  color: Theme.palette.text.main,
                  fontSize: "1.5rem",
                  paddingLeft: "10px",
                }}
              />
            }
            borderRadius={10}
            onClick={() => navigate(-1)}
            color={Theme.palette.tirciary.main}
          />

          <Box sx={{ marginLeft: 3, display: { xs: "none", md: "block" } }}>
            <NeoMenuItem
              icon={require("../@shared/assets/infift_token.png")}
              label={formatNumber(userData.infinityTokens) || 0}
              onClick={() => {}}
              endAdorn={
                <Add
                  style={{
                    marginLeft: 2,
                    fontSize: 20,
                    color: "#fee399",
                  }}
                />
              }
            />
          </Box>
        </Box>

        <Box
          sx={{
            position: "absolute",
            top: "50%",
            right: "2%",
            transform: "translate(0%, -50%)",
            display: { xs: "block", md: "none" },
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <NeoMenuItem
            icon={require("../@shared/assets/infift_token.png")}
            label={userData.infinityTokens || 0}
            onClick={() => {}}
            endAdorn={
              <Add
                style={{
                  marginLeft: 2,
                  fontSize: 20,
                  color: "#fee399",
                }}
              />
            }
          />
        </Box>

        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "2rem", md: "3rem" },
            position: "relative",
            color: Theme.palette.text.main,
            textShadow: ` -2px -2px 0 ${Theme.palette.tirciary.dark}, 2px -2px 0 ${Theme.palette.tirciary.dark}, -2px  2px 0 ${Theme.palette.tirciary.dark}, 2px  2px 0 ${Theme.palette.tirciary.dark}`,
          }}
        >
          SHOP
        </Typography>
      </Box>

      {/* Main Content Row */}
      <Grid
        container
        sx={{
          alignItems: "flex-start",
          justifyContent: "center",
          position: "relative",
          height: "80%",
        }}
      >
        {tab === 0 && (
          <>
            <Grid
              item
              container
              xs={10}
              lg={8}
              style={{
                height: "45%",
                justifyContent: "center",
                backgroundColor: "#2D2D2D95",
                borderRadius: 10,
              }}
            >
              <HorizontalScrollContainer>
                {availCharacters &&
                  availCharacters.map((char) => {
                    return (
                      <Box
                        sx={{
                          borderRadius: 2,
                          width: { xs: "60%", md: "30%" },
                          mx: { xs: 6, md: 0 },
                          aspectRatio: "1 / 1",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <img
                          src={char.imageFin}
                          alt={""}
                          style={{
                            width: "auto",
                            height: "60%",
                            objectFit: "contain",
                            position: "absolute",
                            top: "-6%",
                            right: window.innerWidth < 900 ? "-90%" : "-23%",
                            //   zIndex: 1,
                          }}
                        />
                        <Box
                          sx={{
                            width: { xs: "80%", md: "30%" },
                            height: "fit-content",
                            position: "absolute",
                            bottom: "20%",
                            right: { xs: "-12%", md: "20%" },
                            zIndex: 1,
                          }}
                        >
                          <img
                            src={require("../@shared/assets/blue-banner.png")}
                            alt={""}
                            style={{
                              width: "100%",
                              height: "auto",
                              objectFit: "contain",
                            }}
                          />
                          <Typography
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -30%)",
                              fontWeight: 800,
                              color: Theme.palette.text.main,
                              textShadow: ` -1px -1px 0 ${Theme.palette.tirciary.dark}, 1px -1px 0 ${Theme.palette.tirciary.dark}, -1px  1px 0 ${Theme.palette.tirciary.dark}, 1px  1px 0 ${Theme.palette.tirciary.dark}`,
                              width: "100%",
                              textAlign: "center",
                              lineHeight: 0.95,
                            }}
                          >
                            FEATURED
                            <br />
                            <span
                              style={{ color: Theme.palette.secondary.main }}
                            >
                              ${Number(char.price) * 0.01}
                            </span>
                          </Typography>
                        </Box>
                        <Box style={{ height: "70%" }}>
                          <CharacterCard
                            {...char}
                            heightPer={100}
                            containerHeight={
                              window.innerWidth >= 900 ? 300 : 200
                            }
                          />
                        </Box>
                        <Box
                          style={{
                            width: "100%",
                            marginTop: 20,
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <NeoButton
                            text="Buy"
                            width={50}
                            onClick={() => handleCharacterPurchase(char)}
                            color={Theme.palette.tirciary.main}
                          />
                        </Box>
                      </Box>
                    );
                  })}
              </HorizontalScrollContainer>
            </Grid>

            <Grid
              item
              container
              xs={10}
              lg={8}
              style={{
                height: "45%",
                justifyContent: "center",
                backgroundColor: "#2D2D2D95",
                borderRadius: 10,
              }}
            >
              <HorizontalScrollContainer>
                {tokensForPurchase.map((tokenDeal, idx) => {
                  return (
                    <Box
                      sx={{
                        borderRadius: 2,
                        width: { xs: "53%", md: "30%" },
                        aspectRatio: "1 / 1",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                      }}
                    >
                      <Typography
                        style={{
                          width: "100%",
                          textAlign: "center",
                          fontSize: 20,
                          fontWeight: 800,
                          color: Theme.palette.text.main,
                          textShadow: ` -1px -1px 0 ${Theme.palette.tirciary.dark}, 1px -1px 0 ${Theme.palette.tirciary.dark}, -1px  1px 0 ${Theme.palette.tirciary.dark}, 1px  1px 0 ${Theme.palette.tirciary.dark}`,
                        }}
                      >
                        {tokenDeal.name}
                      </Typography>
                      <img
                        src={tokenDeal.image}
                        alt={""}
                        style={{
                          width: "auto",
                          height: "40%",
                          objectFit: "contain",

                          //   zIndex: 1,
                        }}
                      />
                      <Typography
                        style={{
                          width: "100%",
                          textAlign: "center",
                          fontSize: 20,
                          fontWeight: 800,
                          color: Theme.palette.text.main,
                          textShadow: ` -1px -1px 0 ${Theme.palette.tirciary.dark}, 1px -1px 0 ${Theme.palette.tirciary.dark}, -1px  1px 0 ${Theme.palette.tirciary.dark}, 1px  1px 0 ${Theme.palette.tirciary.dark}`,
                        }}
                      >
                        ${Number(tokenDeal.price * 0.01).toFixed(2)}
                      </Typography>
                      <Box
                        style={{
                          width: "100%",
                          marginTop: 20,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <NeoButton
                          text="Buy"
                          width={50}
                          onClick={() => handleTokenPurchase(tokenDeal)}
                          color={Theme.palette.tirciary.main}
                        />
                      </Box>
                    </Box>
                  );
                })}
              </HorizontalScrollContainer>
            </Grid>
          </>
        )}

        {tab === 1 && (
          <>
            <Grid
              item
              container
              xs={10}
              lg={8}
              style={{
                height: "45%",
                justifyContent: "center",
                backgroundColor: "#2D2D2D95",
                borderRadius: 10,
              }}
            >
              <HorizontalScrollContainer>
                {availInfinityCards &&
                  [...availInfinityCards]
                    .sort((a, b) => {
                      const buffMatchA = a.effect?.match(/(\d+)/) ?? 0;
                      const buffValueA = buffMatchA
                        ? parseInt(buffMatchA[1], 10)
                        : null;

                      const buffMatchB = b.effect?.match(/(\d+)/) ?? 0;
                      const buffValueB = buffMatchB
                        ? parseInt(buffMatchB[1], 10)
                        : null;
                      return buffValueA - buffValueB;
                    })
                    .map((card) => {
                      const buffMatch = card.effect?.match(/(\d+)/) ?? 0;
                      const buffValue = buffMatch
                        ? parseInt(buffMatch[1], 10)
                        : null;
                      const cardPrice = buffValue * 125;
                      return (
                        <Box
                          sx={{
                            borderRadius: 2,
                            width: { xs: "53%", md: "30%" },
                            aspectRatio: "1 / 1",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                          }}
                        >
                          <InfinityCard
                            {...card}
                            heightPer={70}
                            containerHeight={
                              window.innerWidth >= 900 ? 300 : 200
                            }
                          />

                          <Box
                            sx={{
                              width: "45%",
                              mt: "5%",
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "center",
                              alignItems: "center",
                              height: "7.5%",
                            }}
                          >
                            <Box
                              sx={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={require("../@shared/assets/infift_token.png")}
                                alt={""}
                                style={{
                                  width: "auto",
                                  height: "100%",
                                  objectFit: "contain",
                                }}
                              />
                              <Typography
                                style={{
                                  fontSize: 20,
                                  fontWeight: 800,
                                  color: Theme.palette.text.main,
                                  textShadow: ` -1px -1px 0 ${Theme.palette.tirciary.dark}, 1px -1px 0 ${Theme.palette.tirciary.dark}, -1px  1px 0 ${Theme.palette.tirciary.dark}, 1px  1px 0 ${Theme.palette.tirciary.dark}`,
                                }}
                              >
                                {cardPrice}
                                {/* {" / "}$
                                {(cardPrice * 0.01).toFixed(2)} */}
                              </Typography>
                            </Box>
                          </Box>

                          <Box
                            style={{
                              width: "56%",
                              marginTop: "3%",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              gap: 10,
                            }}
                          >
                            <NeoButton
                              startAdorn={
                                <img
                                  src={require("../@shared/assets/infift_token.png")}
                                  alt={""}
                                  style={{
                                    width: "auto",
                                    height: 25,
                                    objectFit: "contain",
                                  }}
                                />
                              }
                              text={"Buy W/ Tokens"}
                              width={100}
                              height={35}
                              onClick={() =>
                                handleInfinityCardPurchaseWithTokens(
                                  card,
                                  cardPrice
                                )
                              }
                              color={Theme.palette.primary.dark}
                            />

                            {/* <NeoButton
                              text="Buy"
                              width={100}
                              height={35}
                              onClick={() =>
                                handleInfinityCardPurchase(card, cardPrice)
                              }
                              color={Theme.palette.tirciary.main}
                            /> */}
                          </Box>
                        </Box>
                      );
                    })}
              </HorizontalScrollContainer>
            </Grid>

            <Grid
              item
              container
              xs={10}
              lg={8}
              style={{
                height: "45%",
                justifyContent: "center",
                backgroundColor: "#2D2D2D95",
                borderRadius: 10,
              }}
            >
              <HorizontalScrollContainer>
                {packsForPurchase.map((pack, idx) => {
                  return (
                    <Box
                      sx={{
                        borderRadius: 2,
                        width: { xs: "53%", md: "30%" },
                        aspectRatio: "1 / 1",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                      }}
                    >
                      <Typography
                        style={{
                          width: "100%",
                          textAlign: "center",
                          fontSize: 20,
                          fontWeight: 800,
                          color: Theme.palette.text.main,
                          textShadow: ` -1px -1px 0 ${Theme.palette.tirciary.dark}, 1px -1px 0 ${Theme.palette.tirciary.dark}, -1px  1px 0 ${Theme.palette.tirciary.dark}, 1px  1px 0 ${Theme.palette.tirciary.dark}`,
                        }}
                      >
                        {pack.name}
                      </Typography>
                      <img
                        src={pack.image}
                        alt={""}
                        style={{
                          width: "auto",
                          height: "65%",
                          objectFit: "contain",

                          //   zIndex: 1,
                        }}
                      />
                      <Typography
                        style={{
                          width: "100%",
                          textAlign: "center",
                          fontSize: 20,
                          fontWeight: 800,
                          color: Theme.palette.text.main,
                          textShadow: ` -1px -1px 0 ${Theme.palette.tirciary.dark}, 1px -1px 0 ${Theme.palette.tirciary.dark}, -1px  1px 0 ${Theme.palette.tirciary.dark}, 1px  1px 0 ${Theme.palette.tirciary.dark}`,
                        }}
                      >
                        ${Number(pack.price * 0.01).toFixed(2)}
                      </Typography>
                      <Box
                        style={{
                          width: "100%",
                          marginTop: 20,
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <NeoButton
                          text="Buy"
                          width={50}
                          color={Theme.palette.tirciary.main}
                          onClick={() => {
                            handlePackPurchase();
                          }}
                        />
                      </Box>
                    </Box>
                  );
                })}
              </HorizontalScrollContainer>
            </Grid>
          </>
        )}

        {tab === 2 && (
          <Grid
            item
            container
            xs={10}
            lg={8}
            sx={{
              height: { xs: "80%", md: "90%", lg: "94%" },
              justifyContent: "center",
              backgroundColor: "#2D2D2D95",
              borderRadius: "10px",
            }}
          >
            <Box
              style={{
                width: 60,
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingTop: 20,
              }}
            >
              {/* avatars */}
              <Box
                style={{
                  marginBottom: 20,
                  height: "fit-content",
                  containerType: "inline-size",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NeoButton
                  isIcon={true}
                  borderRadius={10}
                  icon={
                    <img
                      style={{ width: 30 }}
                      alt=""
                      src={require("../@shared/assets/icons/avatar_icon.png")}
                    />
                  }
                  onClick={() => {
                    setCosmeticsTab(0);
                    if (!avatars) fetchCosmetics("avatars");
                  }}
                  color={
                    cosmeticsTab === 0
                      ? Theme.palette.tirciary.main
                      : Theme.palette.primary.main
                  }
                />
                <Typography
                  style={{
                    fontSize: "18cqw",
                    color: "white",
                    marginTop: 4,
                    fontWeight: 900,
                    textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  2.5px 0 #000`,
                  }}
                >
                  AVATARS
                </Typography>
              </Box>
              {/* skins */}
              <Box
                style={{
                  marginBottom: 20,
                  height: "fit-content",
                  containerType: "inline-size",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NeoButton
                  isIcon={true}
                  borderRadius={10}
                  icon={
                    <img
                      style={{ width: 30 }}
                      alt=""
                      src={require("../@shared/assets/icons/shirt_icon.png")}
                    />
                  }
                  onClick={() => {
                    setCosmeticsTab(1);
                    if (!skins) fetchCosmetics("skins");
                  }}
                  color={
                    cosmeticsTab === 1
                      ? Theme.palette.tirciary.main
                      : Theme.palette.primary.main
                  }
                />
                <Typography
                  style={{
                    fontSize: "20cqw",
                    color: "white",
                    marginTop: 4,
                    fontWeight: 900,
                    textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  2.5px 0 #000`,
                  }}
                >
                  SKINS
                </Typography>
              </Box>
              {/* emotes */}
              <Box
                style={{
                  marginBottom: 20,
                  height: "fit-content",
                  containerType: "inline-size",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NeoButton
                  isIcon={true}
                  borderRadius={10}
                  icon={
                    <img
                      style={{ width: 30 }}
                      alt=""
                      src={require("../@shared/assets/icons/stickers_icon.png")}
                    />
                  }
                  onClick={() => {
                    setCosmeticsTab(2);
                    if (!emotes) fetchCosmetics("emotes");
                  }}
                  color={
                    cosmeticsTab === 2
                      ? Theme.palette.tirciary.main
                      : Theme.palette.primary.main
                  }
                />
                <Typography
                  style={{
                    fontSize: "16cqw",
                    color: "white",
                    marginTop: 4,
                    fontWeight: 900,
                    textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  2.5px 0 #000`,
                  }}
                >
                  EMOTES
                </Typography>
              </Box>
              {/* stickers */}
              <Box
                style={{
                  marginBottom: 20,
                  height: "fit-content",
                  containerType: "inline-size",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NeoButton
                  isIcon={true}
                  borderRadius={10}
                  icon={
                    <img
                      style={{ width: 30 }}
                      alt=""
                      src={require("../@shared/assets/icons/stickers_icon.png")}
                    />
                  }
                  onClick={() => {
                    setCosmeticsTab(3);
                    if (!stickers) fetchCosmetics("stickers");
                  }}
                  color={
                    cosmeticsTab === 3
                      ? Theme.palette.tirciary.main
                      : Theme.palette.primary.main
                  }
                />
                <Typography
                  style={{
                    fontSize: "16cqw",
                    color: "white",
                    marginTop: 4,
                    fontWeight: 900,
                    textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  2.5px 0 #000`,
                  }}
                >
                  STICKERS
                </Typography>
              </Box>
              {/* screens */}
              <Box
                style={{
                  marginBottom: 20,
                  height: "fit-content",
                  containerType: "inline-size",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <NeoButton
                  isIcon={true}
                  borderRadius={10}
                  icon={
                    <img
                      style={{ width: 30 }}
                      alt=""
                      src={require("../@shared/assets/icons/screen_icon.png")}
                    />
                  }
                  onClick={() => {
                    setCosmeticsTab(4);
                    if (!screens) fetchCosmetics("loadingScreens");
                  }}
                  color={
                    cosmeticsTab === 4
                      ? Theme.palette.tirciary.main
                      : Theme.palette.primary.main
                  }
                />
                <Typography
                  style={{
                    fontSize: "18cqw",
                    color: "white",
                    marginTop: 4,
                    fontWeight: 900,
                    textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  2.5px 0 #000`,
                  }}
                >
                  SCREENS
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "calc(100% - 80px)",
                height: "100%",
              }}
            >
              {/* Display the relative items here in a grid layout */}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  gap: 2,
                  overflowY: "auto",
                  p: 2,
                  width: "100%",
                }}
              >
                {loadingCosmetics ? (
                  <Box
                    sx={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress color="secondary" />
                  </Box>
                ) : (
                  <>
                    {(cosmeticsTab === 0
                      ? avatars
                      : cosmeticsTab === 1
                      ? skins
                      : cosmeticsTab === 2
                      ? emotes
                      : cosmeticsTab === 3
                      ? stickers
                      : screens
                    )?.length > 0 ? (
                      (cosmeticsTab === 0
                        ? avatars
                        : cosmeticsTab === 1
                        ? skins
                        : cosmeticsTab === 2
                        ? emotes
                        : cosmeticsTab === 3
                        ? stickers
                        : screens
                      ).map((item) => {
                        const owned = hasUserPurchased(item);
                        return (
                          <Box
                            key={item.id}
                            sx={{
                              width: { xs: "100%", md: "30%", lg: "25%" },
                              backgroundColor: "#ffffff50",
                              borderRadius: 2,
                              border: `3px solid ${Theme.palette.primary.main}`,
                              p: 2,
                              textAlign: "center",
                              boxShadow: 3,
                            }}
                          >
                            <img
                              src={item.image}
                              alt={item.name}
                              style={{
                                width: "80%",
                                //   height: 120,
                                objectFit: "contain",
                                marginBottom: 10,
                              }}
                            />
                            <Typography
                              fontWeight="bold"
                              style={{
                                color: Theme.palette.text.main,
                                textShadow: ` -1px -1px 0 ${Theme.palette.tirciary.main}, 1px -1px 0 ${Theme.palette.tirciary.main}, -1px  1px 0 ${Theme.palette.tirciary.main}, 1px  2.5px 0 ${Theme.palette.tirciary.main}`,
                              }}
                            >
                              {item.name}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                              {item.description}
                            </Typography>
                            {owned ? (
                              <Typography
                                variant="body2"
                                sx={{
                                  color: Theme.palette.secondary.main,
                                  fontWeight: "bold",
                                  textTransform: "uppercase",
                                  margin: "18px 0px",
                                  textShadow: ` -1px -1px 0 ${Theme.palette.tirciary.main}, 1px -1px 0 ${Theme.palette.tirciary.main}, -1px  1px 0 ${Theme.palette.tirciary.main}, 1px  2.5px 0 ${Theme.palette.tirciary.main}`,
                                }}
                              >
                                Already Owned
                              </Typography>
                            ) : (
                              <NeoButton
                                startAdorn={
                                  <img
                                    src={require("../@shared/assets/infift_token.png")}
                                    alt=""
                                    style={{
                                      width: "auto",
                                      height: 25,
                                      objectFit: "contain",
                                    }}
                                  />
                                }
                                text={`${item.tokenPrice} - BUY`}
                                color={Theme.palette.tirciary.main}
                                onClick={() => handleCosmeticPurchase(item)}
                              />
                            )}
                          </Box>
                        );
                      })
                    ) : (
                      <Box
                        sx={{
                          width: "fit-content",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "fit-content",
                          mt: 4,
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#fff",
                            textAlign: "center",
                            width: "100%",
                            textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  2.5px 0 #000`,
                          }}
                        >
                          No items available in this category.
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#fff",
                            textAlign: "center",
                            width: "100%",
                            mt: 0.5,
                            textShadow: ` -1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  2.5px 0 #000`,
                          }}
                        >
                          Please check back later
                        </Typography>
                      </Box>
                    )}
                  </>
                )}
              </Box>
            </Box>
          </Grid>
        )}
      </Grid>

      {/* STORE FOOTER */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: Theme.palette.primary.main,
          borderBottom: `5px solid ${Theme.palette.primary.dark}`,
          borderTop: `5px solid ${Theme.palette.primary.light}`,
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "60px",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "-60%",
            right: "2%",
            display: "flex",
            justifyContent: "space-evenly",
            p: 1,
            width: { xs: "90%", md: "40%" },
            height: "80px",
          }}
        >
          {[
            {
              text: "Featured",
              icon: require("../@shared/assets/icons/star_icon.png"),
            },
            {
              text: "Cards / Packs",
              icon: require("../@shared/assets/icons/book_deck_icon2.png"),
            },
            {
              text: "Cosmetics",
              icon: require("../@shared/assets/icons/profile_icon.png"),
            },
          ].map((tabButton, idx) => {
            return (
              <NeoButton
                key={tabButton}
                color={
                  idx === tab
                    ? Theme.palette.tirciary.main
                    : Theme.palette.primary.main
                }
                text={tabButton.text}
                onClick={() => {
                  setTab(idx);
                }}
                width={30}
                height={50}
                startAdorn={
                  <img
                    src={tabButton.icon}
                    alt=""
                    style={{ width: 30, height: 30 }}
                  />
                }
              />
            );
          })}
        </Box>
      </Box>

      {/* Stripe Checkout Modal */}
      {clientSecret && checkoutOpen && (
        <CheckoutModal
          visible={checkoutOpen}
          onClose={() => setCheckoutOpen(false)}
          clientSecret={clientSecret}
        />
      )}
    </Box>
  );
};

export default StoreScreen;
